import { parseBooleanVal } from "./utils";

function fieldHasUploadedFile(field) {
  const path =
    field.path || field.file_path || field.attachment_path || "";
  const hasPath = String(path).trim().length > 0;
  const value =
    field.value != null && field.value !== undefined
      ? String(field.value).trim()
      : "";
  return hasPath || value.length > 0;
}

function flattenSectionFields(section) {
  const rows = [];
  if (!section?.input_fields) return rows;
  section.input_fields.forEach((field, fieldIndex) => {
    if (field.type !== "sub_section") {
      rows.push({
        name: field.name,
        value: field.value,
        type: field.type,
        sectionIndex: fieldIndex,
        subIndex: null,
      });
    } else {
      (field.sub_fields || []).forEach((subField, subIndex) => {
        rows.push({
          name: subField.name,
          value: subField.value,
          type: subField.type,
          sectionIndex: fieldIndex,
          subIndex,
        });
      });
    }
  });
  return rows;
}

function isDependentFieldShown(element, section) {
  if (
    !parseBooleanVal(element?.is_dependent_field) ||
    !element?.dependent_field_name
  ) {
    return true;
  }
  const tempData = flattenSectionFields(section);
  const fieldIndex = tempData.findIndex(
    (y) => y.name === element.dependent_field_name
  );
  if (fieldIndex === -1) return false;
  const dependentFieldData = tempData[fieldIndex];
  const { sectionIndex, subIndex } = dependentFieldData;
  let dependentFieldValue = null;
  let dependentFieldType = null;

  if (subIndex === null) {
    const f = section.input_fields[sectionIndex];
    if (f) {
      dependentFieldValue = f.value;
      dependentFieldType = f.type;
    }
  } else {
    const subSectionField = section.input_fields[sectionIndex];
    if (subSectionField?.sub_fields?.[subIndex]) {
      const sf = subSectionField.sub_fields[subIndex];
      dependentFieldValue = sf.value;
      dependentFieldType = sf.type;
    }
  }

  if (dependentFieldValue === null || dependentFieldValue === undefined) {
    return false;
  }
  if (dependentFieldType === "checkbox") {
    return (
      parseBooleanVal(dependentFieldValue) ===
      parseBooleanVal(element.dependent_field_value)
    );
  }
  return String(dependentFieldValue) === String(element.dependent_field_value);
}

/**
 * Returns labels of required file fields that have no upload, across all sections.
 * Mirrors dependent-field visibility used in form rendering (section state only).
 */
export function getMissingRequiredDynamicFormFileLabels(sections) {
  const missing = [];
  if (!Array.isArray(sections)) return missing;

  sections.forEach((section) => {
    (section?.input_fields || []).forEach((field) => {
      if (field.type === "sub_section") {
        (field.sub_fields || []).forEach((sub) => {
          if (sub.type !== "file") return;
          if (!parseBooleanVal(sub.required)) return;
          if (!isDependentFieldShown(sub, section)) return;
          if (!fieldHasUploadedFile(sub)) {
            missing.push(sub.lable || sub.label || "Attachment");
          }
        });
        return;
      }
      if (field.type !== "file") return;
      if (!parseBooleanVal(field.required)) return;
      if (!isDependentFieldShown(field, section)) return;
      if (!fieldHasUploadedFile(field)) {
        missing.push(field.lable || field.label || "Attachment");
      }
    });
  });

  return missing;
}
